export type Testimonial = {
  name: string;
  role: string;
  photo: string;
  quote: string;
};

export const testimonials: Testimonial[] = [
  {
    name: "Daniela Morales",
    role: "ICU Nurse",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/a82ff8f1-5ec0-4603-b82c-887808b567be.jpg",
    quote:
      "I appreciate having the hemodynamic parameters organized into one reference collection. The visual explanations make it easier to review cardiovascular physiology and understand how different measurements relate to one another.",
  },
  {
    name: "Marcus Johnson",
    role: "Critical Care RN",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/329596ff-7702-49f2-bb6e-56d4d818f055.jpg",
    quote:
      "The comparison tables are particularly useful for studying concepts such as cardiac output, preload, and afterload. I like being able to review the definitions and then work through educational exercises.",
  },
  {
    name: "Emily Carter",
    role: "Nursing Student",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/2cabeffc-45ce-48af-b6ba-6cde09634f93.jpg",
    quote:
      "Hemodynamic monitoring can feel overwhelming when you’re learning the terminology. Having a structured reference makes it easier to focus on one concept at a time.",
  },
  {
    name: "Javier Ortega",
    role: "ICU Nurse",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/6f7f07a1-3b6d-40f0-bb5e-a6ca3df7cead.jpg",
    quote:
      "The simulated cases are a useful way to practice organizing information. I appreciate the questions that encourage you to consider measurement limitations and missing information.",
  },
  {
    name: "Linda Hayes",
    role: "Critical Care Educator",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/a7559f77-2516-4921-8d69-193ac68997e4.jpg",
    quote:
      "The physiology diagrams and reference tables provide a clear structure for reviewing hemodynamic monitoring concepts. They complement more detailed clinical education.",
  },
  {
    name: "Rosa Delgado",
    role: "Experienced Registered Nurse",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/c855c218-1f26-4c37-a207-da60fa7e87d8.jpg",
    quote:
      "Even after years of practice, I find structured review materials useful. The worksheets and interpretation mistakes library encourage careful thinking about physiological relationships.",
  },
  {
    name: "Kevin Tran",
    role: "Cardiac Step-Down RN",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/96e2cebc-7cd3-4aa3-9851-85c2e8eb0314.jpg",
    quote:
      "I use the 15-minute study review on my days off. Going through one concept at a time with the quick-reference cards beside me made reviewing hemodynamics feel manageable again.",
  },
];
